import React from "react";

import PageLayout from "./PageLayout";
import PreviewCountBadge from "./PreviewCountBadge";

function MechanicsPromoSkeleton({ staking = false }) {
  const cardClassName = staking
    ? "mechanics-promo-skeleton mechanics-promo-skeleton--staking"
    : "mechanics-promo-skeleton mechanics-promo-skeleton--leaderboard";

  return (
    <div className={cardClassName} aria-hidden="true">
      <span className="mechanics-loading-surface mechanics-promo-skeleton__glow" />
      <span className="mechanics-loading-surface mechanics-promo-skeleton__figure" />
      <div className="mechanics-promo-skeleton__copy">
        <span className="mechanics-loading-surface mechanics-promo-skeleton__title" />
        <span className="mechanics-loading-surface mechanics-promo-skeleton__subtitle" />
      </div>
    </div>
  );
}

function MechanicsTileSkeleton({ muted = false }) {
  const tileClassName = muted
    ? "mechanics-square-skeleton mechanics-square-skeleton--muted"
    : "mechanics-square-skeleton";

  return (
    <div className={tileClassName} aria-hidden="true">
      {!muted && (
        <PreviewCountBadge
          value="88"
          tone="dark"
          cornerRadius={20}
          title=""
          className="preview-count-badge--mechanics preview-count-badge--skeleton"
        />
      )}
      <span className="mechanics-loading-surface mechanics-square-skeleton__media" />
      <span className="mechanics-loading-surface mechanics-square-skeleton__label" />
    </div>
  );
}

export default function MechanicsSkeleton() {
  return (
    <PageLayout>
      <div className="mechanics-page-skeleton">
        <MechanicsPromoSkeleton />
        <MechanicsPromoSkeleton staking />
        <div className="mechanics-square-skeleton-grid">
          <MechanicsTileSkeleton />
          <MechanicsTileSkeleton />
          <MechanicsTileSkeleton muted />
        </div>
      </div>
    </PageLayout>
  );
}
